var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto py-16 px-5"},[_c('h1',{staticClass:"text-3xl font-bold text-primary-700"},[_vm._v("Ooops!")]),_vm._v(" "),_c('h2',{staticClass:"text-primary-500"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }